import { TFUSetting } from '../../store/TFUSetting';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getTFUSettings = () => {
  const url = `${process.env.REACT_APP_API_SERVER_URL}/ticket-follow-up-settings`;
  return apiService.callExternalApi<TFUSetting[]>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getAdminTFUSettings = () => {
  const url = `${process.env.REACT_APP_API_SERVER_URL}/ticket-follow-up-settings/admin`;
  return apiService.callExternalApi<TFUSetting[]>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const postTFUSetting = (data: TFUSetting) => {
  return apiService.callExternalApi<TFUSetting>({
    url: `${API_SERVER_URL}/ticket-follow-up-settings`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const putTFUSetting = (data: TFUSetting) => {
  return apiService.callExternalApi<TFUSetting>({
    url: `${API_SERVER_URL}/ticket-follow-up-settings/${data.id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const deleteTFUSetting = (id: string) => {
  return apiService.callExternalApi<null>({
    url: `${API_SERVER_URL}/ticket-follow-up-settings/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
